import { SbsPlayerGlobal } from '../../../common';
import { clamp, importScript, getOS } from '../../../utils';
import { loadLocalStorage } from '../../../utils/storage';

import SbsPlayerLogger from '../../../utils/logger';
import '../../../components/Container/AdWrapper/NetworkAdControls';

class NetInsightXcAdServer {
  constructor() {
    this.position = '';
    this.uuid = '';
    this.tid = '';
    this.ip = '';
    this.url = '';

    this.$adVideo = null;
    this.$adCotainer = null;
    this.adsLoader = null;
    this.adsManager = null;
    this.adDisplayContainer = null;

    this._data = {};
    this._event = {
      initialized: () => {
        console.log(`initialized.`);
      },
      succeeded: () => {
        console.log(`succeeded.`);
      },
      waiting: () => {
        console.log(`waiting.`);
      },
      failed: () => {
        console.log(`failed.`);
      },
      passed: () => {
        console.log(`passed.`);
      },
      errored: () => {
        console.log(`errored.`);
      },
    };
  }

  get data() {
    return this._data;
  }

  set data(data) {
    return (this._data = data);
  }

  get event() {
    return this._event;
  }

  set event(event) {
    return (this._event = event);
  }

  initialize(position) {
    try {
      console.log('#### XC initialize', position);
      this.position = position;

      let adWrapperElement = SbsPlayerGlobal.view.querySelector(
        'sbs-player-ad-wrapper'
      );
      console.log('#### XC initialize - adWrapperElement:', adWrapperElement);
      adWrapperElement.ready();

      // XC 네트워크 광고용 컨트롤러 추가 및 노출
      setTimeout(() => {
        if (
          !adWrapperElement.querySelector('sbs-player-ad-newwork-ad-controls')
        ) {
          console.log('#### XC initialize - adding network ad controls');
          const controlsHTML = `<sbs-player-ad-newwork-ad-controls></sbs-player-ad-newwork-ad-controls>`;
          adWrapperElement.insertAdjacentHTML('beforeend', controlsHTML);
        } else {
          this.showNetworkAdControls();
        }
      }, 100);

      console.log(
        '#### XC initialize - checking google.ima:',
        typeof google !== 'undefined' && typeof google.ima !== 'undefined'
      );
      if (typeof google === 'undefined' || typeof google.ima === 'undefined') {
        console.log('#### XC initialize - loading IMA3 script');
        importScript(SbsPlayerGlobal.url.lib.ima3, () => {
          console.log('#### XC initialize - IMA3 loaded, calling setIMA()');
          this.setIMA();
        });
      } else {
        console.log(
          '#### XC initialize - google.ima already available, calling setIMA()'
        );
        this.setIMA();
      }
    } catch (error) {
      console.log('#### XC initialize - error:', error);
      this._event.errored();
    }
  }

  // 네트워크 광고 컨트롤러 노출 함수
  showNetworkAdControls() {
    try {
      const networkControls = SbsPlayerGlobal.view.querySelector(
        'sbs-player-ad-newwork-ad-controls'
      );
      if (networkControls) {
        networkControls.visible = true;
        console.log('#### XC - Network ad controls shown for XC ad');
      }
    } catch (error) {
      console.error('#### XC - Error showing network ad controls:', error);
    }
  }

  resize() {
    try {
      const wrapper = SbsPlayerGlobal.view.querySelector('.playerWrap');
      if (wrapper) {
        //const origin = SbsPlayerGlobal.view.querySelector('sbs-player-ad-wrapper .playerVideoCont');
        const width = wrapper.clientWidth;
        const height = wrapper.clientHeight;
        this.$adContainer.style.height = height + 'px';
        this.adsManager.resize(width, height);
      }
    } catch (error) {
      console.error(error);
    }
  }

  setIMA(locale) {
    try {
      const videoHeight =
        SbsPlayerGlobal.view.querySelector('.playerWrap').clientHeight;

      this.$adVideo = SbsPlayerGlobal.view.querySelector(
        'sbs-player-ad-wrapper video'
      );
      this.$adContainer = SbsPlayerGlobal.view.querySelector(
        'sbs-player-ad-wrapper .playerADVideoCont'
      );

      this.$adContainer.style.height = videoHeight + 'px';
      this.$adContainer.style.zIndex = 10;

      google.ima.settings.setLocale(locale === undefined ? 'ko' : locale);
      google.ima.settings.setVpaidMode(
        google.ima.ImaSdkSettings.VpaidMode.INSECURE
      );

      this.adDisplayContainer = new google.ima.AdDisplayContainer(
        this.$adContainer,
        this.$adVideo
      );
      this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer);
      this.adsLoader.addEventListener(
        google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
        this.onAdsManagerLoaded,
        false
      );
      this.adsLoader.addEventListener(
        google.ima.AdErrorEvent.Type.AD_ERROR,
        this.onAdError,
        false
      );
      // this.adsLoader.getSettings().setFeatureFlags({ 'disableClickAdPause': true });

      window.addEventListener('resize', () => {
        try {
          this.resize();
        } catch (error) {
          console.error(error);
        }
      });

      SbsPlayerGlobal.events.addEventListener(
        'button-toggle-playpause',
        (play) => {
          console.log('button-toggle-playpause', play);
          if (play) {
            this.adsManager.resume();
          } else {
            this.adsManager.pause();
          }
        }
      );

      // 볼륨 변경 이벤트 처리
      SbsPlayerGlobal.events.addEventListener(
        'input-change-volume',
        (volume) => {
          console.log('XC volume change:', volume);
          if (this.adsManager) {
            this.adsManager.setVolume(volume);
            this.$adVideo.volume = volume;

            // 컨트롤러에 볼륨 변경 알림
            const volumeEvent = {
              target: this.$adVideo,
              currentTarget: this.$adVideo,
              type: 'volumechange',
            };
            SbsPlayerGlobal.events.emitEvent('video-change-ad', volumeEvent);
          }
        }
      );

      // 음소거 토글 이벤트 처리
      SbsPlayerGlobal.events.addEventListener(
        'button-toggle-volume',
        (currentMuted) => {
          console.log('XC mute toggle, current muted state:', currentMuted);
          if (this.adsManager) {
            if (!currentMuted) {
              // 현재 음소거가 아니므로 음소거로 변경 (볼륨 0으로)
              this._savedVolume = this.adsManager.getVolume();
              this.adsManager.setVolume(0);
              this.$adVideo.volume = 0;
              this.$adVideo.muted = true;
              console.log('#### XC - Set to muted (volume 0)');
            } else {
              // 현재 음소거 상태이므로 음소거 해제 (볼륨 0.5로)
              const restoreVolume =
                this._savedVolume ||
                loadLocalStorage(SbsPlayerGlobal.storage.sbsplayer_volume) ||
                0.5;
              this.adsManager.setVolume(restoreVolume);
              this.$adVideo.volume = restoreVolume;
              this.$adVideo.muted = false;
              console.log(
                '#### XC - Set to unmuted (volume',
                restoreVolume + ')'
              );
            }

            // 컨트롤러에 볼륨 변경 알림
            const volumeEvent = {
              target: this.$adVideo,
              currentTarget: this.$adVideo,
              type: 'volumechange',
            };
            SbsPlayerGlobal.events.emitEvent('video-change-ad', volumeEvent);
            console.log(
              '#### XC mute toggle - sent volumechange event, new volume:',
              this.$adVideo.volume,
              'muted:',
              this.$adVideo.muted
            );
          }
        }
      );

      console.log('#### XC setIMA - calling setUrl()');
      this.setUrl();
    } catch (error) {
      console.log('#### XC setIMA - error:', error);
      this._event.errored();
    }
  }

  onAdError = (adErrorEvent) => {
    try {
      const error = adErrorEvent.getError();
      console.log('#### XC onAdError:', error.getType(), error.getMessage());

      // AdError 1205 (사용자 상호작용 필요) 처리
      if (
        error.getType() === 1205 ||
        error.getMessage().includes('user interaction')
      ) {
        console.log(
          '#### XC - User interaction required, adding click-to-play'
        );
        this.addClickToPlayHandler();
        return; // 에러 처리하지 않고 사용자 클릭 대기
      }

      // 다른 에러들은 기존대로 처리
      this._event.errored(error.toString());
      // 컨트롤러 업데이트 정리
      this.stopControllerUpdates();

      // 광고 에러 시 주요 플레이어 요소들 다시 보이기
      const errorPlayerWrapper =
        SbsPlayerGlobal.view.querySelector('sbs-player-wrapper');
      const errorTopArea =
        SbsPlayerGlobal.view.querySelector('sbs-player-toparea');
      if (errorPlayerWrapper) errorPlayerWrapper.style.display = 'block';
      if (errorTopArea) errorTopArea.style.display = 'block';

      // 네트워크 광고 컨트롤러 제거
      const networkControls = SbsPlayerGlobal.view.querySelector(
        'sbs-player-ad-newwork-ad-controls'
      );
      if (networkControls) {
        networkControls.remove();
      }
      if (this.adsManager) {
        this.adDisplayContainer.destroy();
      }
    } catch (error) {
      console.log(error);
      this._event.errored();
    }
  };
  onContentPauseRequested = (event) => {
    try {
      event.type = 'pause';
      SbsPlayerGlobal.events.emitEvent('video-change-ad', event);

      this.$adVideo.pause();
    } catch (error) {
      console.error(error);
    }
  };
  onContentResumeRequested = (event) => {
    try {
      event.type = 'play';
      SbsPlayerGlobal.events.emitEvent('video-change-ad', event);
      //this.$adVideo.play();
    } catch (error) {
      console.error(error);
    }
  };

  onAdEvent = (adEvent) => {
    console.log('adEvent', adEvent);
    let ad = adEvent.getAd();

    // sbs-player-ad-controls와 연동을 위한 이벤트 발생
    const eventData = {
      target: this.$adVideo,
      type: adEvent.type.toLowerCase().replace('_', ''),
      currentTarget: this.$adVideo,
    };

    switch (adEvent.type) {
      case google.ima.AdEvent.Type.LOADED:
        console.log('#### ad.getContentType()', ad.getContentType());
        if (ad.getContentType().includes('image')) {
          console.log('Image ad loaded');
          this._event.errored();
        }

        if (!ad.isLinear()) {
          try {
            SbsPlayerGlobal.events.emitEvent('ima-ad-event', 'LOADED');
            this._event.succeeded(ad);
          } catch (error) {
            console.log(error);
            this._event.errored();
          }
        }
        break;
      case google.ima.AdEvent.Type.STARTED:
        // * SBS로그모듈 - adPlay (network 광고일 경우 예외처리)
        SbsPlayerGlobal.logModule.init(this.$adVideo);
        SbsPlayerGlobal.logModule.adPlay('XC', this.position);
        SbsPlayerGlobal.view
          .querySelector('.playerWrap')
          .classList.add('playerADType');

        // 광고 재생 중 주요 플레이어 요소들 숨기기
        const startedPlayerWrapper =
          SbsPlayerGlobal.view.querySelector('sbs-player-wrapper');
        const startedTopArea =
          SbsPlayerGlobal.view.querySelector('sbs-player-toparea');
        if (startedPlayerWrapper) startedPlayerWrapper.style.display = 'none';
        if (startedTopArea) startedTopArea.style.display = 'none';
        SbsPlayerGlobal.events.emitEvent('ima-ad-event', 'STARTED');

        // 컨트롤러에 재생 시작 알림
        eventData.type = 'play';
        SbsPlayerGlobal.events.emitEvent('video-change-ad', eventData);

        // 사용자 상호작용 시 음소거 해제 로직은 아래 setTimeout 블록에서 처리하도록 통합
        // 중복 처리로 인한 충돌 방지

        // 컨트롤러에 현재 볼륨 상태 즉시 알림 (초기 상태 반영)
        setTimeout(() => {
          // DOM 요소의 속성을 업데이트
          const currentVolume = this.adsManager
            ? this.adsManager.getVolume()
            : 0.5;
          const currentMuted = this.adsManager
            ? this.adsManager.getVolume() === 0
            : false;
          this.$adVideo.volume = currentVolume;
          this.$adVideo.muted = currentMuted;

          const initialVolumeEvent = {
            target: this.$adVideo,
            currentTarget: this.$adVideo,
            type: 'volumechange',
          };
          SbsPlayerGlobal.events.emitEvent(
            'video-change-ad',
            initialVolumeEvent
          );
          console.log(
            '#### XC STARTED - Sent initial volume state with DOM target:',
            currentVolume,
            'muted:',
            currentMuted
          );
        }, 300);

        // 사용자 상호작용 후 볼륨 복원 로직
        let volumeRestored = false;
        const enableAudioOnUserInteraction = () => {
          if (volumeRestored) return; // 중복 실행 방지
          volumeRestored = true;

          console.log(
            '#### XC STARTED - User interaction detected, enabling audio'
          );
          const savedVolume =
            loadLocalStorage(SbsPlayerGlobal.storage.sbsplayer_volume) || 0.5;

          try {
            this.$adVideo.muted = false;
            this.$adVideo.volume = clamp(savedVolume, 0, 1);
            this.adsManager.setVolume(savedVolume);
            console.log('#### XC - Restored volume to:', savedVolume);

            // 컨트롤러에 볼륨 변경 알림
            const volumeEvent = {
              target: this.$adVideo,
              currentTarget: this.$adVideo,
              type: 'volumechange',
            };
            SbsPlayerGlobal.events.emitEvent('video-change-ad', volumeEvent);
          } catch (error) {
            console.error('#### XC - Failed to restore volume:', error);
          }

          // 이벤트 리스너 제거
          document.removeEventListener('click', enableAudioOnUserInteraction);
          document.removeEventListener('keydown', enableAudioOnUserInteraction);
        };

        // 사용자 상호작용을 기다림
        document.addEventListener('click', enableAudioOnUserInteraction);
        document.addEventListener('keydown', enableAudioOnUserInteraction);

        break;
      case google.ima.AdEvent.Type.RESUMED:
        SbsPlayerGlobal.events.emitEvent('ima-ad-event', 'RESUMED');
        // 컨트롤러에 재생 재개 알림
        eventData.type = 'play';
        SbsPlayerGlobal.events.emitEvent('video-change-ad', eventData);
        break;
      case google.ima.AdEvent.Type.PAUSED:
        SbsPlayerGlobal.events.emitEvent('ima-ad-event', 'PAUSED');
        // 컨트롤러에 일시정지 알림
        eventData.type = 'pause';
        SbsPlayerGlobal.events.emitEvent('video-change-ad', eventData);
        break;
      case google.ima.AdEvent.Type.CLICK:
        // * 광고더보기(또는 네트워크 광고에 따라 광고화면 클릭시) 발생 -> 멈추지 않고 그냥 재생하도록
        console.log('CLICK', this.$adVideo.paused);
        this.adsManager.resume();
        this.$adVideo.paused ? this.$adVideo.play() : this.$adVideo.play();
        break;
      case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
        SbsPlayerGlobal.events.emitEvent('ima-ad-event', 'COMPLETED');
        SbsPlayerGlobal.events.emitEvent('ima-all-ads-completed');
        // 컨트롤러 업데이트 정리
        this.stopControllerUpdates();

        // 광고 종료 후 주요 플레이어 요소들 다시 보이기
        const completedPlayerWrapper =
          SbsPlayerGlobal.view.querySelector('sbs-player-wrapper');
        const completedTopArea =
          SbsPlayerGlobal.view.querySelector('sbs-player-toparea');
        if (completedPlayerWrapper)
          completedPlayerWrapper.style.display = 'block';
        if (completedTopArea) completedTopArea.style.display = 'block';

        // 네트워크 광고 컨트롤러 제거
        const networkControls = SbsPlayerGlobal.view.querySelector(
          'sbs-player-ad-newwork-ad-controls'
        );
        if (networkControls) {
          networkControls.remove();
        }
        // 컨트롤러에 종료 알림
        eventData.type = 'ended';
        SbsPlayerGlobal.events.emitEvent('video-change-ad', eventData);
        break;
    }
  };

  startControllerUpdates() {
    try {
      // 이미 타이머가 있다면 정리
      if (this.controllerUpdateInterval) {
        clearInterval(this.controllerUpdateInterval);
      }

      // 이전 볼륨 상태 저장
      this.lastKnownVolume = this.$adVideo ? this.$adVideo.volume : 0;
      this.lastKnownMuted = this.$adVideo ? this.$adVideo.muted : true;

      this.controllerUpdateInterval = setInterval(() => {
        if (this.$adVideo && this.adsManager) {
          // timeupdate 이벤트 발생
          const timeUpdateEvent = {
            target: this.$adVideo,
            currentTarget: this.$adVideo,
            type: 'timeupdate',
          };
          SbsPlayerGlobal.events.emitEvent('video-change-ad', timeUpdateEvent);

          // 볼륨 변경 감지 (강제로 변경된 경우 포함)
          const currentVolume = this.$adVideo.volume;
          const currentMuted = this.$adVideo.muted;

          if (
            Math.abs(currentVolume - this.lastKnownVolume) > 0.001 ||
            currentMuted !== this.lastKnownMuted
          ) {
            console.log(
              '#### XC - Volume change detected via polling:',
              `${this.lastKnownVolume.toFixed(3)} -> ${currentVolume.toFixed(
                3
              )}`,
              `muted: ${this.lastKnownMuted} -> ${currentMuted}`
            );

            // IMA adsManager와 동기화
            this.adsManager.setVolume(currentVolume);

            // 볼륨변경 이벤트 발송
            const volumeEvent = {
              target: this.$adVideo,
              currentTarget: this.$adVideo,
              type: 'volumechange',
            };
            SbsPlayerGlobal.events.emitEvent('video-change-ad', volumeEvent);
            console.log(
              '#### XC - Polling detected volume change, sent to controls'
            );

            // 상태 업데이트
            this.lastKnownVolume = currentVolume;
            this.lastKnownMuted = currentMuted;
          }

          // duration이 설정되었다면 durationchange 이벤트 발생 (한 번만)
          if (this.$adVideo.duration && !this.durationEventSent) {
            const durationEvent = {
              target: this.$adVideo,
              currentTarget: this.$adVideo,
              type: 'durationchange',
            };
            SbsPlayerGlobal.events.emitEvent('video-change-ad', durationEvent);
            this.durationEventSent = true;
          }
        }
      }, 100); // 0.1초마다 업데이트 (더 빠른 감지)
    } catch (error) {
      console.error('Error starting controller updates:', error);
    }
  }

  stopControllerUpdates() {
    try {
      if (this.controllerUpdateInterval) {
        clearInterval(this.controllerUpdateInterval);
        this.controllerUpdateInterval = null;
      }

      // MutationObserver 정리
      if (this.volumeObserver) {
        this.volumeObserver.disconnect();
        this.volumeObserver = null;
        console.log('#### XC - Disconnected volume MutationObserver');
      }
    } catch (error) {
      console.error('Error stopping controller updates:', error);
    }
  }

  addClickToPlayHandler() {
    try {
      // 이미 핸들러가 추가되었다면 중복 방지
      if (this.$adContainer.hasClickHandler) return;

      const clickHandler = () => {
        console.log(
          '#### XC - Ad container clicked, attempting to start ad after user interaction'
        );

        try {
          // 사용자 상호작용 후 광고 재시작 시도
          if (this.adsManager) {
            console.log('#### XC - Attempting to resume ads manager');
            this.adsManager.resume();

            // 볼륨 설정 (초기에는 음소거 상태로)
            this.$adVideo.muted = false;
            let volume =
              loadLocalStorage(SbsPlayerGlobal.storage.sbsplayer_volume) || 0.5;
            this.$adVideo.volume = clamp(volume, 0, 1);
            this.adsManager.setVolume(volume);

            console.log('#### XC - Set volume to:', volume, 'after user click');
          } else {
            // adsManager가 없으면 직접 비디오 재생 시도
            console.log(
              '#### XC - No adsManager, attempting direct video play'
            );
            this.$adVideo.muted = false;
            this.$adVideo
              .play()
              .then(() => {
                console.log('#### XC - Direct video play succeeded');
              })
              .catch((error) => {
                console.log('#### XC - Direct video play failed:', error);
              });
          }

          // 클릭 핸들러 제거 (한 번만 실행)
          this.$adContainer.removeEventListener('click', clickHandler);
          this.$adContainer.hasClickHandler = false;
          this.$adContainer.title = '';
          this.$adContainer.style.cursor = 'default';

          // 클릭 메시지 제거
          if (this._clickMessage) {
            this._clickMessage.remove();
            this._clickMessage = null;
          }
        } catch (error) {
          console.error('#### XC - Error in click handler:', error);
        }
      };

      this.$adContainer.addEventListener('click', clickHandler);
      this.$adContainer.hasClickHandler = true;

      // 시각적 힌트 추가
      this.$adContainer.style.cursor = 'pointer';
      this.$adContainer.title = '클릭하여 광고 재생';

      // 시각적 피드백 메시지 추가
      const clickMessage = document.createElement('div');
      clickMessage.innerHTML = '클릭하여 광고 시청';
      clickMessage.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0,0,0,0.8);
        color: white;
        padding: 12px 24px;
        border-radius: 8px;
        font-size: 16px;
        pointer-events: none;
        z-index: 1001;
      `;
      this.$adContainer.appendChild(clickMessage);
      this._clickMessage = clickMessage;

      console.log('#### XC - Added click-to-play handler and visual hint');
    } catch (error) {
      console.error('Error adding click handler:', error);
    }
  }

  onAdsManagerLoaded = (adsManagerLoadedEvent) => {
    try {
      console.log('adsManagerLoadedEvent', adsManagerLoadedEvent);

      let adsRenderingSettings = new google.ima.AdsRenderingSettings();
      // ? restoreCustomPlaybackStateOnAdBreakComplete: 광고 시간이 완료된 후 SDK가 맞춤 재생 상태를 복원해야 하는지 여부를 지정합니다. 이 설정은 게시자가 맞춤 광고 재생에 사용하기 위해 콘텐츠 플레이어를 전달할 때 주로 사용됩니다.
      adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;
      adsRenderingSettings.enablePreloading = true;
      this.adsManager = adsManagerLoadedEvent.getAdsManager(
        this.$adVideo,
        adsRenderingSettings
      );

      this.adsManager.addEventListener(
        google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,
        () => {
          this.onContentPauseRequested(google.ima.AdEvent);
        },
        false,
        this
      );
      this.adsManager.addEventListener(
        google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
        () => {
          this.onContentResumeRequested(google.ima.AdEvent);
        },
        false,
        this
      );
      this.adsManager.addEventListener(
        google.ima.AdErrorEvent.Type.AD_ERROR,
        this.onAdError,
        false,
        this
      );

      let events = [
        google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
        google.ima.AdEvent.Type.CLICK,
        google.ima.AdEvent.Type.COMPLETE,
        google.ima.AdEvent.Type.FIRST_QUARTILE,
        google.ima.AdEvent.Type.LOADED,
        google.ima.AdEvent.Type.MIDPOINT,
        google.ima.AdEvent.Type.PAUSED,
        google.ima.AdEvent.Type.RESUMED,
        google.ima.AdEvent.Type.STARTED,
        google.ima.AdEvent.Type.THIRD_QUARTILE,
        google.ima.AdEvent.Type.SKIPPED,
      ];
      events.forEach((events) => {
        this.adsManager.addEventListener(events, this.onAdEvent, false, this);
      });

      // Initialize the container. Must be done via a user action on mobile devices.
      this.$adVideo.load();
      // IMA SDK가 자체적으로 재생을 관리하므로 여기서는 play()를 호출하지 않음
      console.log(
        '#### XC - Skipping manual play(), letting IMA SDK handle autoplay'
      );

      // 실시간 볼륨 변경 감지를 위한 이벤트 리스너 추가 (모바일 지원)
      this.$adVideo.addEventListener('volumechange', () => {
        console.log(
          '#### XC - Native volumechange event fired, volume:',
          this.$adVideo.volume,
          'muted:',
          this.$adVideo.muted
        );

        // IMA adsManager와 즉시 동기화
        if (this.adsManager) {
          this.adsManager.setVolume(this.$adVideo.volume);
        }

        // startControllerUpdates의 정기적 감지와 중복되지만 즉시 반응을 위해 추가
        const volumeEvent = {
          target: this.$adVideo,
          currentTarget: this.$adVideo,
          type: 'volumechange',
        };
        SbsPlayerGlobal.events.emitEvent('video-change-ad', volumeEvent);
        console.log(
          '#### XC - Native volumechange event triggered and sent to controls'
        );
      });

      // MutationObserver로 volume 속성 변경 감지 (강제 변경 포함)
      if (window.MutationObserver) {
        this.volumeObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === 'attributes' &&
              (mutation.attributeName === 'volume' ||
                mutation.attributeName === 'muted')
            ) {
              console.log(
                '#### XC - MutationObserver detected volume/muted attribute change'
              );

              // 약간의 딜레이 후 volumechange 이벤트 발송
              setTimeout(() => {
                const volumeEvent = {
                  target: this.$adVideo,
                  currentTarget: this.$adVideo,
                  type: 'volumechange',
                };
                SbsPlayerGlobal.events.emitEvent(
                  'video-change-ad',
                  volumeEvent
                );
                console.log(
                  '#### XC - MutationObserver sent volumechange to controls'
                );
              }, 10);
            }
          });
        });

        this.volumeObserver.observe(this.$adVideo, {
          attributes: true,
          attributeFilter: ['volume', 'muted'],
        });
        console.log(
          '#### XC - MutationObserver setup for volume/muted attributes'
        );
      }

      this.adDisplayContainer.initialize();

      try {
        console.log(
          'adsManager.init',
          this.$adVideo,
          this.$adVideo.clientWidth,
          this.$adVideo.clientHeight
        );

        // 자동재생 정책 때문에 초기에는 음소거 상태로 시작
        console.log(
          '#### XC - Setting initial muted state for autoplay policy compliance'
        );
        this.$adVideo.muted = true;
        this.$adVideo.volume = 0;
        this.$adVideo.setAttribute('muted', 'true');
        this.$adVideo.setAttribute('autoplay', 'true');
        this.$adVideo.setAttribute('playsinline', 'true'); // iOS 지원
        this.adsManager.setVolume(0);

        // AdsManager 설정에 autoplay 관련 옵션 추가
        const adsRenderingSettings = new google.ima.AdsRenderingSettings();
        adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;
        adsRenderingSettings.autoAlign = true;
        adsRenderingSettings.enablePreloading = true;

        this.adsManager.init(
          this.$adVideo.clientWidth,
          this.$adVideo.clientHeight,
          google.ima.ViewMode.NORMAL,
          this.$adVideo,
          adsRenderingSettings
        );

        this.adsManager.start();
        this.resize();

        // 컨트롤러 업데이트를 위한 주기적 이벤트 발생
        this.startControllerUpdates();
      } catch (adError) {
        console.log(error);
        try {
          // * 네트워크광고 자동 재생 오류시 재시도
          //FIXME: 네트워크 광고에서 자동재생(음소거) 폴백
          this.$adVideo.muted = true;
          this.adsManager.setVolume(0);

          this.adsManager.init(
            this.$adVideo.clientWidth,
            this.$adVideo.clientHeight,
            google.ima.ViewMode.NORMAL
          );
          this.adsManager.start();
          this.resize();
        } catch (mutedError) {
          console.error('Failed to start ads even in muted state', mutedError);
          this._event.errored();
        }
      }
    } catch (error) {
      console.log(error);
      this._event.errored();
    }
  };

  setUrl() {
    try {
      console.log('#### XC setUrl - _data:', this._data);
      console.log('#### XC setUrl - position:', this.position);

      let url =
        this._data[this.position === 'live_midroll' ? 'midroll' : this.position]
          .link;

      console.log('#### XC setUrl - extracted url:', url);

      if (url) {
        this.url = new URL(url);
        // HTTPS 강제 적용 (크롬 Mixed Content 정책 대응)
        this.url.protocol = 'https:';

        let uuid = this.uuid;
        let tid = this.tid;
        let ip = this.ip;
        let cmparam = this._data.cmparam;

        console.log('#### XC setUrl - uuid:', uuid, 'tid:', tid, 'ip:', ip);
        console.log('#### XC setUrl - cmparam:', cmparam);

        let params = new URLSearchParams(cmparam);
        params.set('d.os', getOS());
        params.set('d.ifa', uuid);
        params.set('d.lmt', '0');
        params.set('d.model', '');
        params.set('d.w', '');
        params.set('d.h', '');
        params.set('d.ip', ip);
        params.set('u.customdata', '');
        params.set('i.v.api', '');
        params.set('i.v.startdelay', '');
        params.set('i.v.w', this.$adVideo.clientWidth);
        params.set('i.v.h', this.$adVideo.clientHeight);
        params.set('slots', '');
        params.set('rurl', encodeURIComponent(document.location.href));
        this.url = this.url.href + '?' + params.toString();

        console.log('#### XC setUrl - final url:', this.url);
        this._event.initialized();
      } else {
        console.log('#### XC setUrl - no url found, calling passed()');
        this._event.passed();
      }
    } catch (error) {
      console.log('#### XC setUrl - error:', error);
      this._event.errored();
    }
  }

  requestAd() {
    try {
      console.log(this.position, this.url);

      // ===== TEMP TEST CODE - COMMENTED OUT FOR PRODUCTION =====
      // Google test ad options (uncomment desired one for testing):

      // Option: 기본 15초 광고
      const testUrl =
        'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dlinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=' +
        Date.now();

      // Option: VMAP 광고 시퀀스 (여러 광고)
      // const testUrl = 'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ct%3Dvmap&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&correlator=' + Date.now();

      // Option 4: 스킵 가능한 15초 광고
      // const testUrl = 'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_preroll_skippable&sz=640x480&cust_params=sample_ct%3Dskippablelinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=' + Date.now();

      // console.log('#### XC TEST - Using Google test VAST URL');
      // ===== END TEMP TEST CODE =====

      let adsRequest = new google.ima.AdsRequest();
      adsRequest.adTagUrl = this.url; // Production: Use real XC URL
      //adsRequest.adTagUrl = testUrl; // !Testing: Uncomment this and testUrl above
      adsRequest.linearAdSlotWidth = this.$adVideo.clientWidth;
      adsRequest.linearAdSlotHeight = this.$adVideo.clientHeight;
      adsRequest.nonLinearAdSlotWidth = this.$adVideo.clientWidth;
      adsRequest.nonLinearAdSlotHeight = this.$adVideo.clientHeight;

      // 자동재생 정책 준수를 위한 설정
      adsRequest.setAdWillAutoPlay(true);
      adsRequest.setAdWillPlayMuted(true);

      console.log(
        '#### XC requestAd - Set autoplay=true, muted=true for browser policy compliance'
      );
      this.adsLoader.requestAds(adsRequest);
    } catch (error) {
      console.log(error);
      this._event.errored(error);
    }
  }
}

export default NetInsightXcAdServer;
